import styles from "../../styles/Product.module.css";
import { ProductModel} from "../../models/product";
import { formatGR } from "../../utils/formatGR";
import { Button, Card, Row, Col, Form } from "react-bootstrap";
import { useShopContext } from "../../context/ShopContext";
import { useRef, useState } from "react";

interface ProductProps {
    product: ProductModel
}

const Product = ({ product }: ProductProps) => {

    // We create a reference to the inputbox in order to select its text when it is clicked.
    const textFieldRef = useRef<HTMLInputElement>(null);

    const {
        ID,
        NAME,
        CODE,
        BRAND,
        FACTORYCODE,
        PRICE,
        QUANTITY,
        MAX,
        UNIT,
    } = product;

    const { addItem, removeItem, manualAddRemoveItem, getCartAmount } = useShopContext();
    const [isFlashing, setIsFlashing] = useState(false);
    const flashTrigger = () => {
        setIsFlashing(true); // Set isFlashing to true
        // Schedule a function to set isFlashing back to false after 1 second
        setTimeout(() => {
          setIsFlashing(false); // Set isFlashing back to false
        }, 2000); // 1000 milliseconds = 1 second
      };

    return (
        <Card className={`${styles.productCard} bg-light text-dark my-1 border-0`}>
            <Card.Header className={`${styles.cardHeader} d-flex justify-content-between bg-dark text-light p-2`}>
                <div>Κωδικός: {CODE}</div>
                <div>Μάρκα: {BRAND}</div>
                <div>SKU: {FACTORYCODE}</div>
            </Card.Header>
            <Card.Body className={`${styles.cardBody} d-flex justify-content-between align-items-center`}>

                <Col>
                    <Row>
                        <Card.Title className={`${styles.cardTitle} fs-6`}>
                            {NAME}
                        </Card.Title>
                    </Row>
                </Col>
                <Col className="px-3 col col-lg-auto">
                    <Row className="justify-content-end align-items-center">
                        <Button className={`${styles.ButtonMinus} bg-dark border-0 ${Number(QUANTITY) === 0 ? 'disabled' : ''}`} onClick={() => {
                            removeItem(ID);
                        }}>
                        </Button>
                        <Form.Control ref={textFieldRef} type="text" name="quantityinput" inputMode="numeric" pattern="[0-9]*" className={`${styles.FormControl}`} disabled={Number(QUANTITY) === 0} value={getCartAmount(ID)} onChange={ (e)=> {
                                if (Number(e.target.value) <= QUANTITY) {
                                    manualAddRemoveItem(ID, product, Number(e.target.value));
                                    setTimeout(() => { textFieldRef.current?.blur(); }, 2000);
                                } else {
                                    flashTrigger();
                                    textFieldRef.current?.blur();
                                }
                            }}
                        onClick={() => {
                            if (textFieldRef.current) {
                                textFieldRef.current.select();  //select inputbox text on click
                            }
                        }}
                        />
                        <Button className={`${styles.ButtonPlus} bg-dark border-0 ${Number(QUANTITY) === 0 ? 'disabled' : ''}`} onClick={()=>{
                            if (Number(textFieldRef.current?.value) + 1 <= Number(QUANTITY)) {
                                addItem(ID, product);
                            } else {
                                flashTrigger();
                            }
                        }}>
                        </Button>
                        {UNIT}
                    </Row>
                </Col>
            </Card.Body>
            <Card.Footer className={`${styles.cardFooter} d-flex justify-content-between p-2`}>
            {MAX && (
                QUANTITY / MAX === 0 ? <div className={`${styles.availability} text-light bg-danger rounded ${isFlashing ? 'flash' : ''}`}>Μη διαθέσιμο</div> :
                QUANTITY / MAX <= 0.15 ? <div className={`${styles.availability} text-dark bg-warning rounded ${isFlashing ? 'flash' : ''}`}>Πολύ χαμηλό απόθεμα</div> :
                QUANTITY / MAX <= 0.3 ? <div className={`${styles.availability} text-dark bg-warning rounded ${isFlashing ? 'flash' : ''}`}>Χαμηλό απόθεμα</div> :
                <div className={`${styles.availability} text-light bg-success rounded ${isFlashing ? 'flash' : ''}`}>Σε απόθεμα</div>
            )}
                <div>Τιμή (με ΦΠΑ): {formatGR(PRICE)}€</div>
            </Card.Footer>
        </Card>
    )
}

export default Product;